<template>
  <div class="public">
    <div class="container HomeTrade">
      <!-- 四色码 -->
      <Toptab :topdata="forCodeData" :data="dataregion" />
      <!-- 商户区域分布情况 中国地图 -->
      <div class="idiot-two echarts">
        <div class="echarts-box">
          <div class="echarts-tit">
            <span>预付交易区域分布图</span>
          </div>
        </div>

        <div class="map-charts">
          <Baidumap
            v-if="regionType >= 3 && areaName"
            v-loading="showbmap"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            :regionName="regionName"
            :flag="flag"
            :cityName="cityName"
            :areaName="areaName"
            :data="baidumapOptions"
          />
          <Pmap
            v-else
            v-loading="showmap"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            :regionName="regionName"
            :cityName="cityName"
            :flag="flag"
            :mapOptions="mapOptions"
          ></Pmap>
        </div>
      </div>
      <!-- 预付码新增变化趋势 折线图图 -->
      <div class="idiot-two echarts">
        <div class="echarts-box">
          <div class="echarts-tit">
            <span>预付交易新增变化趋势</span>
          </div>
          <KcSelect left="0" top="18" @popupVal="popupVal"></KcSelect>
        </div>
        <div class="charts">
          <LineChart
            :chartData="lineChartData1"
            v-loading="lineChart1"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            :legendData="[]"
            :units="units1"
            :yAxis="yAxis1"
            :yAxisIndex="[0]"
          ></LineChart>
        </div>
        <Tab :optionData="tabData" @popupswitch="popupVal2"></Tab>
      </div>
      <!-- 预付码累计变化趋势 折线图图 -->
      <div class="idiot-two echarts">
        <div class="echarts-box">
          <div class="echarts-tit">
            <span>预付交易累计变化趋势</span>
          </div>
          <KcSelect left="0" top="18" @popupVal="popupVal3"></KcSelect>
        </div>
        <div class="charts">
          <LineChart
            :chartData="lineChartData2"
            v-loading="lineChart2"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            :legendData="[]"
            :units="units2"
            :yAxis="yAxis2"
            :yAxisIndex="[0]"
          ></LineChart>
        </div>
        <Tab :optionData="tabData" @popupswitch="popupVal4"></Tab>
      </div>
      <!-- 预付码按城市/地区统计 表格 -->
      <div class="idiot-two echarts">
        <div class="echarts-box">
          <div class="echarts-tit">
            <span>预付交易区域分布数量统计</span>
          </div>
          <!-- <div class="h-selct">
            <el-select v-model="hairpinType1" placeholder="请选择" size="mini">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.haripinType"
                :label="item.name"
                :value="item.haripinType"
              ></el-option>
            </el-select>
          </div> -->
          <KcSelect
            isBlue
            keyLabel="haripinType"
            :optionData="options"
            right="10"
            top="-35"
            @popupVal="popupVal5"
          ></KcSelect>
        </div>
        <div class="element-tab">
          <el-table
            :data="tableDataAll"
            v-loading="loading1"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            style="width: 100%"
            :row-key="rowKey"
            lazy
            :load="loadNextNode1"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            @sort-change="changeSort"
            :header-cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              prop="regionName"
              label="地区"
              :width="0.18 * $bodyWidth"
              fixed
            ></el-table-column>
            <el-table-column
              prop="num"
              label="笔数"
              sortable
              :width="0.21 * $bodyWidth"
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.num }}</span
                ><i
                  :class="
                    scope.row.numSign > 0
                      ? 'num-badge-blue'
                      : scope.row.numSign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.numSign > 0
                      ? "+" + scope.row.numSign
                      : scope.row.numSign < 0
                      ? "" + scope.row.numSign
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="cardMoney"
              label="发卡金额"
              sortable
              :width="0.25 * $bodyWidth"
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.cardMoney }}</span
                ><i
                  :class="
                    scope.row.cardMoneySign > 0
                      ? 'num-badge-blue'
                      : scope.row.cardMoneySign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.cardMoneySign > 0
                      ? "+" + scope.row.cardMoneySign
                      : scope.row.cardMoneySign < 0
                      ? "" + scope.row.cardMoneySign
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="unMoney"
              label="兑付金额"
              :width="0.25 * $bodyWidth"
              sortable
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.unMoney }}</span
                ><i
                  :class="
                    scope.row.unMoneySign > 0
                      ? 'num-badge-blue'
                      : scope.row.unMoneySign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.unMoneySign > 0
                      ? "+" + scope.row.unMoneySign
                      : scope.row.unMoneySign < 0
                      ? "" + scope.row.unMoneySign
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="ratio"
              label="兑付比"
              :width="0.25 * $bodyWidth"
              sortable
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.ratio }}%</span
                ><i
                  :class="
                    scope.row.ratioSign > 0
                      ? 'num-badge-blue'
                      : scope.row.ratioSign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.ratioSign > 0
                      ? "+" + scope.row.ratioSign + "%"
                      : scope.row.ratioSign < 0
                      ? "" + scope.row.ratioSign + "%"
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="page-btn" v-if="tableData1.length > 10">
            <el-button type="text" @click="showAll = !showAll"
              >{{ showAll ? "收起全部" : "展开全部"
              }}<i
                class="el-icon-d-arrow-left el-icon--right"
                :class="showAll ? 'rotate-top' : 'rotate-bottom'"
              ></i
            ></el-button>
          </div>
        </div>
      </div>
      <!-- 预付码按领域/行业统计 表格 -->
      <div class="idiot-two echarts">
        <div class="echarts-box">
          <div class="echarts-tit">
            <span>预付交易领域/行业分布数量统计</span>
          </div>
          <KcSelect
            isBlue
            keyLabel="haripinType"
            :optionData="options"
            right="10"
            top="-35"
            @popupVal="popupVal6"
          ></KcSelect>
        </div>
        <div class="element-tab">
          <el-table
            :data="tableDataAll2"
            v-loading="loading2"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            style="width: 100%"
            row-key="industryId"
            lazy
            :load="loadNextNode2"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            @sort-change="changeSort2"
            :header-cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              prop="industryName"
              label="领域/行业"
              :width="0.32 * $bodyWidth"
              fixed
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="笔数"
              sortable
              :width="0.21 * $bodyWidth"
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.num }}</span
                ><i
                  :class="
                    scope.row.numSign > 0
                      ? 'num-badge-blue'
                      : scope.row.numSign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.numSign > 0
                      ? "+" + scope.row.numSign
                      : scope.row.numSign < 0
                      ? "" + scope.row.numSign
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="cardMoney"
              label="发卡金额"
              sortable
              :width="0.25 * $bodyWidth"
            >
              <template slot-scope="scope">
                <span class="num-box">{{
                  scope.row.cardMoney | numFilter
                }}</span
                ><i
                  :class="
                    scope.row.cardMoneySign > 0
                      ? 'num-badge-blue'
                      : scope.row.cardMoneySign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.cardMoneySign > 0
                      ? "+" + scope.row.cardMoneySign
                      : scope.row.cardMoneySign < 0
                      ? "" + scope.row.cardMoneySign
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="unMoney"
              label="兑付金额"
              :width="0.25 * $bodyWidth"
              sortable
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.unMoney | numFilter }}</span
                ><i
                  :class="
                    scope.row.unMoneySign > 0
                      ? 'num-badge-blue'
                      : scope.row.unMoneySign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.unMoneySign > 0
                      ? "+" + scope.row.unMoneySign
                      : scope.row.unMoneySign < 0
                      ? "" + scope.row.unMoneySign
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="ratio"
              :width="0.25 * $bodyWidth"
              label="兑付比"
              sortable
            >
              <template slot-scope="scope">
                <span class="num-box">{{ scope.row.ratio }}%</span
                ><i
                  :class="
                    scope.row.ratioSign > 0
                      ? 'num-badge-blue'
                      : scope.row.ratioSign < 0
                      ? 'num-badge-orag'
                      : 'none'
                  "
                  >{{
                    scope.row.ratioSign > 0
                      ? "+" + scope.row.ratioSign + "%"
                      : scope.row.ratioSign < 0
                      ? "" + scope.row.ratioSign + "%"
                      : ""
                  }}</i
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="page-btn" v-if="tableData2.length > 10">
            <el-button type="text" @click="showAll2 = !showAll2"
              >{{ showAll2 ? "收起全部" : "展开全部"
              }}<i
                class="el-icon-d-arrow-left el-icon--right"
                :class="showAll2 ? 'rotate-top' : 'rotate-bottom'"
              ></i
            ></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import LineChart from "@/components/charts/line2"; // 四码折线图
import Pmap from "@/components/charts/map"; //地图
import Tab from "@/components/tab.vue";
import Baidumap from "@/components/baidumap/index.vue";
import {
  transactionInfo,
  cashingStatistics,
  transactionAdd,
  transactionCumulative,
  transactionCityStatistics,
  transactionIndustryStatistics,
} from "@/api/hometrade";
import { cardType } from "@/api/common";
import Toptab from "@/components/toptab.vue";

export default {
  name: "HomeTrade",
  props: {
    regionName: [String],
    areaName: [String],
    cityName: [String],
    flag: [String, Number],
    regionId: [String, Number],
    regionType: [String, Number],
  },
  data() {
    return {
      lineChart1: false,
      lineChart2: false,
      hairpinType1: "",
      hairpinType2: "",
      options: [],
      radio1: "1",
      radio2: "1",
      radioData1: [
        {
          name: "近一周",
          value: "1",
        },
        {
          name: "近一月",
          value: "2",
        },
        {
          name: "近半年",
          value: "3",
        },
        {
          name: "全部",
          value: "4",
        },
      ],
      tabData: [
        {
          name: "交易笔数",
          haripinType: 1,
        },
        {
          name: "交易金额",
          haripinType: 2,
        },
        {
          name: "兑付金额",
          haripinType: 3,
        },
        {
          name: "兑付比",
          haripinType: 4,
        },
      ],
      lineChartData1: {
        xAxisData: [],
        seriesData: [
          {
            name: "交易笔数",
            data: [],
          },
        ],
      },
      lineChartData2: {
        xAxisData: [],
        seriesData: [
          {
            name: "黑码",
            data: [],
          },
          {
            name: "红码",
            data: [],
          },
          {
            name: "黄码",
            data: [],
          },
          {
            name: "绿码",
            data: [],
          },
        ],
      },
      showAll: false,
      loading1: false,
      loading2: false,
      tableDataAll: [],
      tableData1: [],
      showAll2: false,
      tableDataAll2: [],
      tableData2: [],
      mapOptions: [],
      forCodeData: [],
      dataregion: [],
      tabPosition: 1,
      tabPosition2: 1,
      units1: [""],
      units2: [""],
      yAxis1: [""],
      yAxis2: [""],
      baidumapOptions: [],
      showmap: true,
      showbmap: true,
    };
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
  },
  computed: {
    costRequest() {
      return {
        regionName: this.regionName,
        areaName: this.areaName,
        cityName: this.cityName,
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
      };
    },
  },
  watch: {
    costRequest: {
      handler(val, oldVal) {
        //console.log('homepage',val)
        this.intData();
      },
      deep: true, //增加deep 观察对象的子对象变化
    },
    radio1: function (val) {
      this.transactionAdd();
    },
    tabPosition: function (val) {
      this.transactionAdd();
    },
    radio2: function (val) {
      this.transactionCumulative();
    },
    tabPosition2: function (val) {
      this.transactionCumulative();
    },
    hairpinType1: function (val) {
      this.transactionCityStatistics();
    },
    hairpinType2: function (val) {
      this.transactionIndustryStatistics();
    },
    showAll: function (val) {
      this.showAllData();
    },
    showAll2: function (val) {
      this.showAllData2();
    },
  },
  mounted() {
    this.intData();
  },
  methods: {
    popupVal(val) {
      this.radio1 = val;
    },
    popupVal2(val) {
      this.tabPosition = val.haripinType;
    },
    popupVal3(val) {
      this.radio2 = val;
    },
    popupVal4(val) {
      this.tabPosition2 = val.haripinType;
    },
    popupVal5(val) {
      this.hairpinType1 = val;
    },
    popupVal6(val) {
      this.hairpinType2 = val;
    },
    intData() {
      this.cardType();
      this.getMapOptionData();
      this.cashingStatistics();
      this.transactionAdd();
      this.transactionCumulative();
      this.transactionCityStatistics();
      this.transactionIndustryStatistics();
    },
    cardType() {
      cardType().then((res) => {
        res.data.unshift({ name: "全部", haripinType: "" });
        this.options = res.data;
      });
    },
    getMapOptionData() {
      this.showbmap = true;
      this.showmap = true;
      transactionInfo({
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
      })
        .then((res) => {
          //console.log('预付卡交易分布情况:',res)
          //this.mapOptions = res.data;
          let data = [];
          res.data.forEach((item) => {
            data.push({
              name: item.regionName,
              value: item.num,
              money: item.money,
              ratio: item.ratio,
            });
          });
          this.mapOptions = data;
          this.showmap = false;
          if (this.regionType >= 3 && this.areaName) {
            this.baidumapOptions = data;
            this.showbmap = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cashingStatistics() {
      cashingStatistics({
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
      })
        .then((res) => {
          let topdata = [];
          let data = [
            {
              name: "较昨日",
              data: [],
            },
            {
              name: "较上周",
              data: [],
            },
            {
              name: "较上月",
              data: [],
            },
            {
              name: "较上年",
              data: [],
            },
          ];
          res.data.map((v, i) => {
            data[0].data.push(
              v.type == 1
                ? parseFloat(v.yesterdayNum)
                : parseFloat(v.yesterdayNum).toFixed(2)
            );
            data[1].data.push(
              v.type == 1
                ? parseFloat(v.weekNum)
                : parseFloat(v.weekNum).toFixed(2)
            );
            data[2].data.push(
              v.type == 1
                ? parseFloat(v.monthNum)
                : parseFloat(v.monthNum).toFixed(2)
            );
            data[3].data.push(
              v.type == 1
                ? parseFloat(v.yearNum)
                : parseFloat(v.yearNum).toFixed(2)
            );
            topdata.push({
              // val: v.type !== 4 ?  parseFloat(v.num).toFixed(2) : parseFloat(v.num).toFixed(2),
              val: v.type !== 1 ? parseFloat(v.num).toFixed(2) : v.num,
              com:
                v.type == 1
                  ? "笔"
                  : v.type == 2
                  ? "元"
                  : v.type == 3
                  ? "元"
                  : v.type == 4
                  ? "%"
                  : "",
              name:
                v.type == 1
                  ? "交易笔数"
                  : v.type == 2
                  ? "交易金额"
                  : v.type == 3
                  ? "兑付金额"
                  : v.type == 4
                  ? "兑付比"
                  : "",
            });
          });
          this.dataregion = data;
          this.forCodeData = topdata;
          console.log(res.data, "1111111111", data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    transactionAdd() {
      let _this = this;
      this.lineChart1 = true;
      transactionAdd({
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
        type: this.radio1,
      }).then((res) => {
        //console.log('预付交易新增变化趋势',res)
        this.lineChart1 = false;
        if (res.data != null) {
          this.lineChartData1 = {
            xAxisData: res.data.x_axis,
            seriesData: [
              {
                name:
                  _this.tabPosition == 1
                    ? "交易笔数"
                    : _this.tabPosition == 2
                    ? "交易金额"
                    : _this.tabPosition == 3
                    ? "兑付金额"
                    : _this.tabPosition == 4
                    ? "兑付比"
                    : "交易笔数",
                data:
                  _this.tabPosition == 1
                    ? res.data.num
                    : _this.tabPosition == 2
                    ? res.data.cashing
                    : _this.tabPosition == 3
                    ? res.data.unCashing
                    : _this.tabPosition == 4
                    ? res.data.ratio
                    : [],
              },
            ],
          };
        } else {
          this.lineChartData1 = {
            xAxisData: [],
            seriesData: [
              {
                name:
                  _this.tabPosition == 1
                    ? "交易笔数"
                    : _this.tabPosition == 2
                    ? "交易金额"
                    : _this.tabPosition == 3
                    ? "兑付金额"
                    : _this.tabPosition == 4
                    ? "兑付比"
                    : "交易笔数",
                data: [],
              },
            ],
          };
        }
        _this.units1 =
          _this.tabPosition == 1
            ? ["笔"]
            : _this.tabPosition == 2
            ? ["元"]
            : _this.tabPosition == 3
            ? ["元"]
            : _this.tabPosition == 4
            ? ["%"]
            : ["笔"];
        _this.yAxis1 = _this.tabPosition == 4 ? ["%"] : [""];
      });
    },
    transactionCumulative() {
      let _this = this;
      this.lineChart2 = true;
      transactionCumulative({
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
        type: this.radio2,
      }).then((res) => {
        //console.log('预付交易累计变化趋势',res)
        this.lineChart2 = false;
        if (res.data != null) {
          this.lineChartData2 = {
            xAxisData: res.data.x_axis,
            seriesData: [
              {
                name:
                  _this.tabPosition2 == 1
                    ? "交易笔数"
                    : _this.tabPosition2 == 2
                    ? "交易金额"
                    : _this.tabPosition2 == 3
                    ? "兑付金额"
                    : _this.tabPosition2 == 4
                    ? "兑付比"
                    : "交易笔数",
                data:
                  _this.tabPosition2 == 1
                    ? res.data.num
                    : _this.tabPosition2 == 2
                    ? res.data.cashing
                    : _this.tabPosition2 == 3
                    ? res.data.unCashing
                    : _this.tabPosition2 == 4
                    ? res.data.ratio
                    : [],
              },
            ],
          };
        } else {
          this.lineChartData2 = {
            xAxisData: [],
            seriesData: [
              {
                name:
                  _this.tabPosition2 == 1
                    ? "交易笔数"
                    : _this.tabPosition2 == 2
                    ? "交易金额"
                    : _this.tabPosition2 == 3
                    ? "兑付金额"
                    : _this.tabPosition2 == 4
                    ? "兑付比"
                    : "交易笔数",
                data: [],
              },
            ],
          };
        }
        _this.units2 =
          _this.tabPosition2 == 1
            ? ["笔"]
            : _this.tabPosition2 == 2
            ? ["元"]
            : _this.tabPosition2 == 3
            ? ["元"]
            : _this.tabPosition2 == 4
            ? ["%"]
            : ["笔"];
        _this.yAxis2 = _this.tabPosition2 == 4 ? ["%"] : [""];
      });
    },
    transactionCityStatistics() {
      this.loading1 = true;
      transactionCityStatistics({
        hairpinType: this.hairpinType1,
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
      }).then((res) => {
        //console.log('预付码按城市/地区统计',res)
        // res.data.forEach(item => {
        //   item.hasChildren = true;
        // })
        this.loading1 = false;
        this.tableDataAll = [];
        this.$nextTick(() => {
          this.tableData1 = res.data;
          this.tableDataAll = this.tableData1.slice(0, 10);
          this.showAllData();
        });
      });
    },
    showAllData() {
      if (!this.showAll) {
        this.tableDataAll = this.tableData1.slice(0, 10);
      } else {
        this.tableDataAll = this.tableData1;
      }
    },
    //确保row-key不重复
    rowKey(row) {
      return row.regionName + row.regionId;
    },
    loadNextNode1(tree, treeNode, resolve) {
      //console.log(tree, treeNode, resolve)
      transactionCityStatistics({
        hairpinType: this.hairpinType1,
        regionId: tree.regionId,
        regionType: tree.regionType,
        flag: tree.regionType,
      }).then((res) => {
        //console.log('预付码按城市/地区统计-二级',res)
        // res.data.forEach(item => {
        //   item.hasChildren = true;
        // })
        resolve(res.data);
      });
    },
    transactionIndustryStatistics() {
      this.loading2 = true;
      transactionIndustryStatistics({
        hairpinType: this.hairpinType2,
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
      }).then((res) => {
        //console.log('预付码按领域/行业统计',res)
        res.data.forEach((item) => {
          item.hasChildren = true;
        });
        this.loading2 = false;
        this.tableDataAll2 = [];
        this.$nextTick(() => {
          this.tableData2 = res.data;
          this.tableDataAll2 = this.tableData2.slice(0, 10);
          this.showAllData2();
        });
      });
    },
    showAllData2() {
      if (!this.showAll2) {
        this.tableDataAll2 = this.tableData2.slice(0, 10);
      } else {
        this.tableDataAll2 = this.tableData2;
      }
    },
    loadNextNode2(tree, treeNode, resolve) {
      //console.log(tree, treeNode, resolve)
      transactionIndustryStatistics({
        hairpinType: this.hairpinType2,
        industryId: tree.industryId,
        regionId: this.regionId,
        regionType: this.regionType,
        flag: this.flag,
      }).then((res) => {
        //console.log('预付码按领域/行业统计-二级',res)
        resolve(res.data);
      });
    },
    changeSort(column, prop, order) {
      this.tableDataAll = this.tableData1;
      this.showAll = true;
    },
    changeSort2(column, prop, order) {
      this.tableDataAll2 = this.tableData2;
      this.showAll2 = true;
    },
  },
  components: {
    LineChart,
    Pmap,
    Tab,
    Baidumap,
    Toptab,
  },
};
</script>

<style lang="scss" scoped >
.HomeTrade {
  // 四色码
  .idiot-one {
    display: flex;
    flex-wrap: wrap;
    height: 420px;
    margin-bottom: 30px;
    background: white;
    font-size: 26px;
    color: #232a24;

    .boxtop {
      width: 100%;
      height: 128px;
      border-bottom: 1px solid #ececec;
      display: flex;
      align-items: center;
      .boxtopchild {
        width: 25%;
        height: 100%;
        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 50%;
        }
        & > div:nth-child(2) {
          color: #1d67ff;
        }
      }
    }
    .boxval {
      width: 100%;
      .boxvalchild {
        width: 100%;
        height: 62px;
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #eeeeee;
        .boxvalchildname {
          width: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .t {
          color: #ffba00;
          font-weight: bold;
        }
        .b {
          color: #59d2f3;
          font-weight: bold;
        }
      }
    }

    .box {
      width: 33%;
      text-align: center;
      .box-header {
        color: #b4b9c1;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 14px;
        span:nth-child(1) {
          font-size: 18px;
        }
        span:nth-child(2) {
          font-size: 30px;
          margin: 0 10px;
        }
      }
      .box-one {
        display: flex;
        justify-content: center;
        font-size: 14px;
        line-height: 32px;
        span:nth-child(1) {
          color: #9fa1a7;
        }
        span:nth-child(2) {
          color: #eee;
          width: 60px;
          text-align: left;
        }
        span:nth-child(3) {
          color: #eee;
          width: 10px;
          font-size: 16px;
          .t {
            color: #ffba00;
            font-weight: bold;
          }
          .b {
            color: #59d2f3;
            font-weight: bold;
          }
        }
      }
    }
  }
  .tab-select-btn {
    position: absolute;
    top: 6px;
    right: 0;
    &.right-size {
      right: 120px;
    }
  }
}
</style>

